import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css';

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>etravo - Terms & Conditions</title>
        <meta name="description" content="Terms & Conditions of Etravo" />
      </Helmet>

      <section
        className="page-title"
        style={{ backgroundImage: 'url(images/background/3.jpg)' }}
      >
        <div className="auto-container">
          <h1>Terms & Conditions</h1>
          <div className="bread-crumb-outer"></div>
        </div>
      </section>

      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            <div className="col-md-12">
              <div className="terms-content">
                <h2>Terms and Conditions</h2>
                <p>
                  In the below Terms and Conditions, "you" and "your" means any, all persons who booked the trip and are part of the trip (including those who joined after alteration). "We", "us" and "our" means Etravo. By continuing so, you are agreeing to follow our “Terms and Conditions”, together with our “Privacy Policy” controlled by the website of Etravo. We had tried to provide all the information in as simple words as possible, still in case of any confusion, doubts you can write to us for clarification.
                </p>

                <h3>Alteration To User(s) Agreement</h3>
                <p>
                  Etravo may change, modify, amend, or update these terms and conditions from time to time without any prior notification to user(s) and the altered and reaffirmed terms and conditions will be effective immediately on posting in our website. By continuing, the usage of our Services will signify your acceptance of the altered terms and conditions.
                </p>

                <h3>Booking Criteria</h3>
                <p>
                  You must permit enough time while booking your taxi, for any delay caused by the traffic, or weather conditions. Etravo shall not be responsible for any delay caused by your failure to allow enough time to reach your destination or if the guest(s) are not ready at time of pickup.
                </p>
                <p>
                  You must order the car as per your space requirements with the number of guests and luggage being carried. Etravo cannot guarantee to carry luggage beyond the TRA guidelines allowed.
                </p>

                <h3>Price, Booking and Payment Policy</h3>
                <p>
                  The tariff listed on our website excludes the Taxes, Parking Charges, Toll Tax Charges, State Permit Charges, Sightseeing entrance charges, Guide Services and Waiting Charges.
                </p>
                <p>
                  Once the booking is confirmed, we will send you the final quotation on your phone after receiving all the details. Please check your booking confirmation carefully and inform us of any errors promptly.
                </p>
                <p>
                  Booking confirmation will be sent to the registered mobile number or email ID provided during registration.
                </p>
                <p>
                  Payment methods include Cash, Demand Draft, Cheque, and Online transfer via Credit/Debit Card, Mobile Apps, or Net Banking. Payment can be made in person or online, for yourself or others.
                </p>

                <h4>Bank Details</h4>
                <ul>
                  <li><b>Beneficiary:</b> Etravo</li>
                  <li><b>Address:</b> Etravo Office, 163, Adarsh Colony, Tingre Nagar Lane No.09, Airport Road - Pune-411032</li>
                  <li><b>Bank:</b> ICICI Bank Ltd, Branch, Alandi Road</li>
                  <li><b>Account No:</b> 777705140036</li>
                  <li><b>IFSC Code:</b> ICIC0004000</li>
                </ul>

                <h3>General Policy</h3>
                <p>
                  Etravo office is considered the start and end point for rental calculations:
                </p>
                <ul>
                  <li><b>Start Time:</b> When the driver leaves for customer pickup.</li>
                  <li><b>End Time:</b> When the driver returns to the Etravo office after drop-off.</li>
                </ul>
                <p>
                  Distance traveled is used to calculate the final rate. After 24 hours, 25% extra will be charged per km beyond the permitted limit.
                </p>
                <p>
                  Night charges apply after 12:00 midnight, and an extra day is counted irrespective of the start time.
                </p>
                <p>
                  Vehicle availability is subject to availability. If the booked vehicle is unavailable, an equivalent will be provided.
                </p>
                <p>
                  Smoking, alcohol, and narcotics are strictly prohibited in the vehicle.
                </p>
                <p>
                  Guests are responsible for any damage or excessive dirt caused to the vehicle.
                </p>

                <h3>Cancellation Policy</h3>
                <h4>Multi-Day Journey</h4>
                <ul>
                  <li>0% charges if cancelled before 48 hours</li>
                  <li>30% charges if cancelled before 36 hours</li>
                  <li>60% charges if cancelled before 24 hours</li>
                  <li>100% charges if cancelled within 24 hours</li>
                </ul>

                <h4>Single-Day Journey</h4>
                <ul>
                  <li>Airport Pickup/Drop: 100% if cancelled below 4 hours, 0% if before</li>
                  <li>Packages/Quick Trips: 100% if cancelled below 4 hours, 0% if before</li>
                </ul>

                <h3>Refund Policy</h3>
                <p>
                  Cancellation charges apply as per the cancellation policy above. Eligible refunds will be processed within 5–7 working days using the original payment method.
                </p>
              </div>
            </div>
          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>For any queries regarding our terms, feel free to reach out:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+919356411908">+91 9356411908</a></li>
              <li><b>Email:</b> <a href="mailto:booking@etravo.in">booking@etravo.in</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
